import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import api from '@services/api';
import type { PortfolioType } from '@customTypes/portfolio';

const useGetList = () => {
  const [portfolios, setPortfolios] = useState<PortfolioType[]>([]);
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);

  const getPortfolios = useCallback(async ({ page = 1, limit = 10, query = '' }) => {
    setLoading(true);
    try {
      const response = await api.get('/portfolio', {
        params: {
          pageIndex: page,
          pageLimit: limit,
          query,
        },
      });
      setPortfolios(response.data.data);
      setTotalPages(response.data.total);
    } catch {
      toast.error('Erro ao carregar portfólios. Tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getPortfolios,
    portfolios,
    totalPages,
    loading,
  };
};

export default useGetList;
